import { RequestService } from "../../../../../common/services/RequestService";
import { CREATE_ORDER } from "../constants";
import { dataCreateOrderRequest } from "./dataAdjustment";

export const createOrderRequest = async (profileId, data, ymaps) => {
  const adjustedData = await dataCreateOrderRequest(data, ymaps);
  const response = await RequestService.post(
    CREATE_ORDER.replace("{profile_id}", profileId),
    adjustedData
  );
  return response && response.data;
};
